@if (status() === 'loading') {
<app-view-state [status]="'loading'" [title]="loadingTitle" [subtitle]="loadingSubtitle"></app-view-state>
}

@if (status() === 'loaded') {
<app-skip-links></app-skip-links>

@if (global()?.navbar; as navbar) {
<app-navbar [navbar]="navbar" id="navigation" tabindex="-1"></app-navbar>
}

<main id="main-content" aria-label="Contenido principal" tabindex="-1">
  <app-breadcrumb [attr.aria-hidden]="isHome ? 'true' : null"></app-breadcrumb>
  <router-outlet></router-outlet>
</main>

@if (global()?.footer; as footer) {
<app-footer [footerData]="footer" class="footer" id="footer" tabindex="-1"></app-footer>
}
}

@if (status() === 'error') {
<app-view-state [status]="'error'" [title]="errorTitle" [subtitle]="errorSubtitle"></app-view-state>
}